import API from 'aurora-api';
import * as urls from 'aurora-api/urls';
import { ACTIVE_URL } from 'aurora-utils/constants';

const { BASE_URL } = ACTIVE_URL;

const api = new API(BASE_URL);

class BuyersListService {
  static getNationalities = () => api.get(urls.OFFPLAN.GET_NATIONALITIES);

  static fetchBuyerList = data => api.get(urls.OFFPLAN.BUYER_LIST, null, data);

  static addBuyer = data => api.post(urls.OFFPLAN.ADD_BUYER_NON_RESIDENT, data);
}

export default BuyersListService;
